











































































































import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import {
  store,
  bus,
  client,
  checkAuth,
  toPascalCase,
  splitOnFirst,
} from '../shared';
import { validationMixin } from 'vuelidate';
import { Authenticate } from '../shared/dtos';
import { redirect, Routes } from '../shared/router';
import { Validations } from 'vuelidate-property-decorators';
import {
  required,
  minLength,
  between,
  email,
  decimal,
  integer,
  url,
  sameAs,
  alphaNum,
} from 'vuelidate/lib/validators';
import VueSweetalert2 from 'vue-sweetalert2';

@Component({})
export default class SignIn extends Vue {
  /* ------------- Data -------------------- */
  $v: any;
  form: any = {
    userName: null,
    password: null,
  };
  rememberMe = true;
  loading = false;
  responseStatus = null;

  @Validations()
  validations: any = {
    form: {
      userName: {
          required,
          alphaNum,
      },
      password: {
        required,
      },
    },
   };

  /* ------------- Computed ---------------- */
  get store() {
    return store;
  }

  /* ------------- Methods ----------------- */
  async submit() {
    try {
      this.loading = true;
      this.responseStatus = null;

      const response = await client.post(
        new Authenticate({
          provider: 'credentials',
          userName: this.form.userName,
          password: this.form.password,
          rememberMe: this.rememberMe,
        }),
      );

      bus.$emit('signin', response);

      redirect((this.$route.query.redirect as string) || Routes.Home);
    } catch (e) {
      this.responseStatus = e.responseStatus || e;
    } finally {
      this.loading = false;
    }
  }
  /* ------------- Lifecycle Hooks --------- */
  protected mounted() {
      if (this.store.userSession != null) {
      redirect((this.$route.query.redirect as string) || Routes.Home);
    }
  }
}
